// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"2d77d127","299":"2e215e1a","435":"85cc640e","948":"82939107"}[chunkId] + ".chunk.css";
};